import type { CartType, ModifyCartItemByDecoratedProduct } from '../model';
import { createEcommerceTrackingData } from './createEcommerceTrackingData';
import {
  G4_EVENT_NAME_ADD_TO_CART,
  G4_EVENT_NAME_ADD_TO_REQUESTCART
} from '~/lib/constants';

export async function createAddToCartAnalyticsEvent(
  type: CartType,
  cartId: string,
  cartItems: ReadonlyArray<ModifyCartItemByDecoratedProduct>,
  source?: string
) {
  if (!cartItems.length) {
    // eslint-disable-next-line no-console
    console.warn(
      'need at least one element to add to cart to create an analytics event - aborting.'
    );

    return;
  }

  const item = await createEcommerceTrackingData({
    cartItems,
    source
  });

  const { user } = useOidcAuth();

  switch (type) {
    case 'cart':
      return {
        event: G4_EVENT_NAME_ADD_TO_CART,
        cart_id: cartId,
        userId: user?.value?.claims?.oid?.toString() ?? 'null',
        ecommerce: item
      };
    case 'requestCart':
      return {
        event: G4_EVENT_NAME_ADD_TO_REQUESTCART,
        cart_id: cartId,
        userId: user?.value?.claims?.oid?.toString() ?? 'null',
        custom: item
      };
  }
}
